import { render } from "./OTCOnTheMarketPage.vue?vue&type=template&id=77e6066d&scoped=true"
import script from "./OTCOnTheMarketPage.vue?vue&type=script&lang=js"
export * from "./OTCOnTheMarketPage.vue?vue&type=script&lang=js"

import "./OTCOnTheMarketPage.vue?vue&type=style&index=0&id=77e6066d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e6066d"]])

export default __exports__